import { render } from "./MultiGrafAnimated.vue?vue&type=template&id=1a35caca"
import script from "./MultiGrafAnimated.vue?vue&type=script&lang=js"
export * from "./MultiGrafAnimated.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__